import Quill from 'quill'

let Embed = Quill.import('blots/embed')
import VariableHelpers from '@/assets/js/variableHelpers.js'
import EventBus from '@/assets/js/eventBus.js'
import Store from '@/store/store.js'

// a simple blot to represent an editor variable.
class VariableBlot extends Embed {
	static create(variable) {
		let node = super.create()
		node.innerText = VariableHelpers.getPrettyName(variable.name, Store.getters.combinedVariables)
		node.setAttribute('title', VariableHelpers.removeBrackets(variable.name))
		node.setAttribute('name', variable.name)
		node.setAttribute('styles', variable.styling)
		// node.setAttribute('display-name', variable.displayName || '' )
		node.setAttribute('display-name', variable.displayName || '' || variable.name.substring(17, variable.name.length-1))
		node.setAttribute('formatting', variable.formatting || '')
		node.classList.add('variable-blot')
		node.addEventListener('click', event => {
			// Store.dispatch('variableClicked', { node, variable, event })
			EventBus.$emit('variableClicked', { node, variable, event })
		})
		return node
	}

	static formats(node) {
		return {
			name: node.getAttribute('title'),
			displayName: node.getAttribute('display-name'),
			formatting: node.getAttribute('formatting'),
			styling: node.getAttribute('styling')
		}
	}
	
	static value(node) {
		return {
			name: node.getAttribute('name'),
			displayName: node.getAttribute('display-name'),
			formatting: node.getAttribute('formatting'),
			styling: node.getAttribute('styling')
		}
	}
}

VariableBlot.blotName = 'variable'
VariableBlot.tagName = 'span'
VariableBlot.className = 'variable-blot-class'
// Quill.register(VariableBlot, true)
export default VariableBlot
